export default __webpack_public_path__ + "static/media/step_04.877db168.png";